import { createContext, type ReactNode, useMemo } from 'react';

type ErrorBoundaryContextType = {
  sentryEnabled: boolean;
};

export const ErrorBoundaryContext = createContext<ErrorBoundaryContextType>({
  sentryEnabled: false,
});

type ErrorBoundaryProviderProps = {
  readonly children: ReactNode;
  readonly sentryEnabled: boolean;
};

export const ErrorBoundaryProvider = ({
  children,
  sentryEnabled,
}: ErrorBoundaryProviderProps) => {
  const context = useMemo(() => {
    return {
      sentryEnabled,
    };
  }, [sentryEnabled]);

  return (
    <ErrorBoundaryContext.Provider value={context}>
      {children}
    </ErrorBoundaryContext.Provider>
  );
};
